import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
    baseURL: `${BACKEND_URL}/api`,
    headers: { "Content-Type": "application/json" },
});

const TOKEN_KEY = "pills.token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => {
    if (t) localStorage.setItem(TOKEN_KEY, t);
    else localStorage.removeItem(TOKEN_KEY);
};

api.interceptors.request.use((config) => {
    const t = getToken();
    if (t) config.headers.Authorization = `Bearer ${t}`;
    return config;
});

api.interceptors.response.use(
    (r) => r,
    (error) => {
        // pass through; UI decides how to handle
        return Promise.reject(error);
    }
);
